<template>
  <v-text-field
    v-model="priceInput"
    :class="{ 'centered-input': textCenter }"
    :dense="$attrs['dense']"
    :error-messages="error != null ? error : []"
    :label="$attrs['label'] || 'Enter Price'"
    :messages="priceString"
    :readonly="$attrs['readonly']"
    append-icon="mdi-currency-rial"
    outlined
    @input="formatPrice"
    @keypress="isNumberKey"
    :hint="$attrs['hint']"
    persistent-hint
  />
</template>
<script>
export default {
  name: "priceInput",

  props: {
    value: {
      type: Number,
      default: 0,
    },
    error: [String, null],
    textCenter: Boolean,
  },

  data: () => ({
    priceInput: "",
  }),

  // created: function (event) {
  //   this.$emit('priceInput', this.convertToRealPrice(this.value + ""))
  // },
  //
  // mounted() {
  //   this.input = this.convertToHumanReadablePrice(this.value + "");
  // },

  // watch: {
  //   value: function (val) {
  //     if (val.toString().length > (this.maxLength ?? 10)) {
  //       console.log("in > 10")
  //       let fix = "";
  //       for (let i = 0; i < (this.maxLength ?? 10); i++) {
  //         fix = fix + "9";
  //       }
  //       console.log(fix)
  //       this.$emit('priceInput', this.convertToRealPrice(fix))
  //       return;
  //     }
  //     this.input = this.convertToHumanReadablePrice(this.value);
  //     if ((this.value + "").length > 10) {
  //       let fixPrice = this.convertToRealPrice((this.value + "").substring(0, 10));
  //       this.$emit('priceInput', fixPrice)
  //       this.input = this.convertToHumanReadablePrice(fixPrice);
  //     }
  //   },
  // },

  mounted() {
    this.priceInput = this.computedValue;
    this.$nextTick(() => {
      this.formatPrice();
    });
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    priceString() {
      return (
        this.persian(parseFloat(this.value / 10).toLocaleString()) + " تومان"
      );
    },
  },

  watch: {
    computedValue(val, oldVal) {
      if (!oldVal) {
        this.priceInput = val;
        this.$nextTick(() => {
          this.formatPrice();
        });
      }
    },
  },

  methods: {
    formatPrice() {
      let value = this.priceInput.toString().replace(/,/g, "");
      this.computedValue = Number(value);

      if (!isNaN(value) && value.length > 0) {
        this.priceInput = parseFloat(value).toLocaleString();
      } else {
        this.priceInput = "";
      }
    },
    // convertToHumanReadablePrice(input) {
    //   return (this.english(input.toString())).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    // },

    // convertToRealPrice(input) {
    //   return parseInt(this.english(input ? (input.toString()).replace(/,/g, '') : '0'))
    // },

    // handleInput(e) {
    //   this.$emit('priceInput', this.convertToRealPrice(e))
    // },

    isNumberKey: function (evt) {
      let persianChars = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        persianChars.indexOf(evt.key) === -1
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
